import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { ProtectedRoute } from './components/ProtectedRoute'
import { Layout } from './components/Layout'
import { LoginPage } from './pages/LoginPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { VideosPage } from './pages/VideosPage'
import { ReportsPage } from './pages/ReportsPage'
import { AiReportsPage } from './pages/AiReportsPage'
import { UsersPage } from './pages/UsersPage'
import { AuditPage } from './pages/AuditPage'
import { AdminsPage } from './pages/AdminsPage'
import { WaitlistPage } from './pages/WaitlistPage'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/videos" replace />} />
                  <Route path="/videos" element={<VideosPage />} />
                  <Route path="/reports" element={<ReportsPage />} />
                  <Route path="/ai-reports" element={<AiReportsPage />} />
                  <Route path="/users/:userId" element={<UsersPage />} />
                  <Route path="/audit" element={<AuditPage />} />
                  <Route path="/admins" element={<AdminsPage />} />
                  <Route path="/waitlist" element={<WaitlistPage />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthProvider>
  )
}

export default App
